import styled, { keyframes } from "styled-components";

/* ===== animação (mais lenta) ===== */
const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(26px); }
  to   { opacity: 1; transform: translateY(0); }
`;

/* ===== tokens simples ===== */
const surface = "rgba(18, 27, 40, 0.92)";
const stroke = "rgba(255, 255, 255, 0.10)";
const text1 = "var(--text-primary, #EAF1FF)";
const text2 = "var(--text-secondary, #B8C5DA)";

/* ===== mantém seu Wrapper ===== */
export const Wrapper = styled.div`
  padding:80px 16px;
  display:flex;
  flex-direction:column;
  align-items:center;
  gap:32px;
  position:relative;

  /* visual opcional */
  width:100%;
  overflow:hidden;

  &.is-visible .card {
    animation: ${fadeUp} 1.1s cubic-bezier(.22,.61,.36,1) forwards;
  }

  @media (min-width: 768px){ padding: 32px 64px; }
  @media (min-width: 1440px){ padding: 48px 120px; }
`;

export const Title = styled.h2`
  font-weight: 700;
  font-style: Bold;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: 1px;
  text-align: center;

  @media (min-width: 850px){
    font-size: 40px;
    line-height: 48px;
    letter-spacing: 2px;
  }
`;

/* ===== GRID =====
   mobile: 1 col
   tablet: 2 col
   desktop: 5 col (para permitir os spans 1-3-1 / 2-1-2)
*/
export const Grid = styled.div`
  display:grid;
  grid-template-columns: 1fr;
  gap:16px;
  max-width: 1200px;

  @media (min-width:768px){
    grid-template-columns: repeat(2, minmax(0,1fr));
  }

  @media (min-width:1200px){
    grid-template-columns: repeat(5, minmax(0,1fr));
  }
`;

/* ===== CARD ===== */
export const Card = styled.article.attrs({ className: "card" })`
  padding:16px;
  background:var(--color-0a1323);
  border-radius:8px;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 16px;

  /* ===== LAYOUT ESPECÍFICO (desktop ≥1200px) ===== */
  @media (min-width:1200px){
    /* linha 1: [1,3,1] */
    &:nth-child(1){ grid-column: span 1; }
    &:nth-child(2){ grid-column: span 3; }
    &:nth-child(3){ grid-column: span 1; }

    /* linha 2: [2,1,2] */
    &:nth-child(4){ grid-column: span 2; }
    &:nth-child(5){ grid-column: span 1; }
    &:nth-child(6){ grid-column: span 2; }
  }
`;

export const Head = styled.header`
  display:flex;
  align-items:center;
  gap:8px;
`;

export const Avatar = styled.img`
  width:32px;
  height:32px;
  border-radius:50%; 
`;

export const Name = styled.div`
  font-weight: 700;
  font-style: bold;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0px;
`;

export const Role = styled.div`
  font-weight: 400;
  font-style: Regular;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0px;

`;

export const Text = styled.p`
  font-weight: 400;
  font-style: Regular;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0px;
`;
